module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/feature03-4fd7b24bd297ac21ee07eebd5c4137f8.svg";